"use client";
import { useInkeepConfig as m } from "../providers/config-provider.js";
import { useChatMarkdown as a } from "../providers/markdown-provider.js";
import { toKebabCase as i } from "../utils/misc.js";
function u(o, n) {
  const { prefix: t } = m(), e = a(), s = p(o, e) ? e?.componentStyles?.[o] : void 0, r = `${t}-${i(o)}`;
  return [n, s, r].filter(Boolean).join(" ");
}
function p(o, n) {
  return !!n?.componentStyles && o in n.componentStyles;
}
export {
  u as useComponentClassNames
};
